<template>
    <!-- mensagens lado cliente -->
    <div
        :data-evento-id="evento.id"
        class="flex items-start hover:bg-gray-50 rounded-sm dark:hover:bg-dark-750 p-1 group min-w-0 ml-2 mr-2"
        :class="{
            'mt-1 p-1 ': evento.anteriorEnviadoPelaMesmaPessoa,
            'mt-4 p-1 ': !evento.anteriorEnviadoPelaMesmaPessoa,
        }"
    >
        <div v-if="!evento.anteriorEnviadoPelaMesmaPessoa" class="w-12 h-12 pt-1 flex-shrink-0">
            <alo-avatar :src="avatarDoAutor" class="w-9 h-9 rounded-sm" />
        </div>
        <div v-else class="w-12 -mt-1 flex-shrink-0">
            <span class="text-gray-400 opacity-0 group-hover:opacity-100" style="font-size: 9px">{{ horaEnvio }} </span>
        </div>

        <div class="w-full relative group min-w-0">
            <div class="absolute top-0 right-0 rounded overflow-hidden hidden group-hover:block z-10">
                <button
                    :title="__('Responder')"
                    class="p-1 bg-white text-gray-500 hover:text-black"
                    @click="dispatchQuotedMessage()"
                >
                    <alo-icon icon="outline-reply" class="w-4 h-4" />
                </button>
            </div>

            <div
                v-if="
                    evento.atributos_extras &&
                    evento.atributos_extras.anexos &&
                    evento.atributos_extras.anexos.length > 0
                "
                class="-m-3 mb-2 p-1 rounded-t-lg bg-black-20%"
            >
                <AnexosIndex :anexos="evento.atributos_extras.anexos" :mostrar-remover="false" :event-id="evento.id" />
            </div>

            <div v-if="hasError">
                <div class="bg-red-600 text-red-100 rounded-full px-2">{{ __('Falha no envio de mensagem.') }}</div>
            </div>

            <div class="text-sm" v-if="!evento.anteriorEnviadoPelaMesmaPessoa">
                <span class="text-xs">{{ nomeDoAutor }} </span>
                <span class="text-gray-400 pl-2" style="font-size: 9px">{{ horaEnvio }}</span>
            </div>

            <div v-if="quotedMessage" class="text-xs border p-2 bg-gray-50 dark:bg-dark-800 rounded">
                <div v-html="__('<b>:name</b>', { name: quotedMessage.name })"></div>
                <alo-purified-html class="font-light text-sm break-words" :html="quotedMessage.body" />
            </div>

            <alo-purified-html
                class="text-base break-words"
                :class="estiloDaMensagemDependendoDaQuantidadeDeEmojis"
                :html="corpoHtml"
            />

            <Options
                v-if="
                    evento.atributos_extras &&
                    evento.atributos_extras.options &&
                    Array.isArray(evento.atributos_extras.options) &&
                    evento.atributos_extras.options.length > 0
                "
                :options="evento.atributos_extras.options"
                @select="$emit('select-option', $event)"
            />

            <div class="flex items-center pt-1 -mb-1">
                <div
                    v-show="evento.enviadoPeloUserAtual && evento.id_temporário"
                    class="ml-1"
                    :class="{
                        'text-primary-300': evento.enviadoPeloUserAtual,
                        'text-gray-500': !evento.enviadoPeloUserAtual,
                    }"
                    :title="__('Enviando...')"
                >
                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                </div>

                <AcksShow
                    v-if="evento.enviadoPeloUserAtual && !evento.id_temporário && evento.visibility == 'public'"
                    :acks="evento.atributos_extras.acks"
                    :perfil="perfil"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { formatarHoraAmigável, utcParaLocal } from '@Shared/Date'
import AnexosIndex from '@App/Vue/Remote/Chat/Eventos/Anexos/Index.vue'
import Options from './Options.vue'
import AcksShow from './Acks/Show.vue'

export default {
    components: { AnexosIndex, AcksShow, Options },
    props: {
        evento: Object,
        sala: Object,
        perfil: Function,
        userProfile: Function,
        contactProfile: Function,
        showAvatar: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        horaEnvio() {
            return formatarHoraAmigável(utcParaLocal(this.evento.created_at))
        },

        avatarDoAutor() {
            if (this.evento.autor_type == 'core_users') {
                return this.userProfile(this.evento.autor_id).url_avatar_32px
            } else if (this.evento.autor_type == 'crm_contacts') {
                return this.contactProfile(this.evento.autor_id).url_avatar_32px
            } else if (this.evento.autor_type == 'auto') {
                return asset('/img/teclia_auto_avatar.png')
            } else {
                if (this.sala.canal_atual == 'whatsapp_qr_code' && this.evento.visibility == 'public') {
                    return asset('/img/logo_whatsapp.png')
                }
            }
            return asset('/img/teclia_auto_avatar.png')
        },

        nomeDoAutor() {
            if (this.evento.autor_type == 'core_users') {
                return this.userProfile(this.evento.autor_id).name
            } else if (this.evento.autor_type == 'crm_contacts') {
                return this.contactProfile(this.evento.autor_id).name
            } else {
                return __('Téclia')
            }
        },

        /**
         * Citação de resposta.
         */
        quotedMessage() {
            return this.evento.atributos_extras.quoted_message
        },

        /**
         * Houve falha no envio da mensagem?
         *
         * @return {boolean}
         */
        hasError() {
            if (this.evento.atributos_extras.error) {
                let acks = this.evento.atributos_extras.acks || {}
                let hasContactAck = false
                Object.keys(acks).forEach((key) => {
                    if (key.indexOf('crm_contact') !== -1) hasContactAck = true
                })
                return !hasContactAck
            }

            return false
        },

        /**
         * HTML da mensagem que pode ser inserido no DOM de forma de segura.
         *
         * @return {string}
         */
        corpoHtml() {
            if (this.sala.canal_atual == 'whatsapp_qr_code') {
                if (this.evento.autor_type == 'self' && this.evento.visibility == 'public') {
                    return (
                        (this.evento.corpo_html || this.plainTextFormatting(this.evento.corpo_texto)) +
                        '<br /><i class="text-sm">' +
                        __('Essa mensagem foi enviada pelo celular') +
                        '</i>'
                    )
                }
            }

            if (!this.evento.corpo_html && this.evento.corpo_texto) {
                return this.plainTextFormatting(this.evento.corpo_texto)
            }

            if (!this.evento.corpo_texto && !this.evento.corpo_html) return ''

            return this.evento.corpo_html
        },

        /**
         * A ideia por trás é que mensagens com só um emoji devem aparecer grandes.
         * - Com dois emojis um pouco maior.
         * - Com três ou mais o texto é padrão.
         */
        estiloDaMensagemDependendoDaQuantidadeDeEmojis() {
            if (!this.evento.corpo_texto) return ''
            if (this.evento.corpo_texto.length > 15) return ''
            let lengthMáximoParaEmojisÚnicos = 8
            if (this.evento.corpo_texto.length <= lengthMáximoParaEmojisÚnicos) {
                let msgSemEmoji = this.evento.corpo_texto.replace(
                    /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|\uD83E[\uDD10-\uDD5D])/g,
                    ''
                )
                let qtdeEmoji = this.fancyCount(this.evento.corpo_texto) - this.fancyCount(msgSemEmoji)
                if (qtdeEmoji >= 1 && !this.evento.corpo_texto.match(/\w+/)) {
                    return 'text-4xl'
                }
            }
            return ''
        },
    },
    methods: {
        dispatchQuotedMessage() {
            document.dispatchEvent(
                new CustomEvent('chat:quote-message', {
                    detail: {
                        room_id: this.sala.id,
                        name: this.nomeDoAutor,
                        body: this.corpoHtml,
                    },
                })
            )
        },

        fancyCount(str) {
            return Array.from(str.split(/[\ufe00-\ufe0f]/).join('')).length
        },

        plainTextFormatting(body) {
            if (!body) return body

            return (
                '<pre class="font-sans break-words whitespace-pre-wrap">' +
                body
                    .replace(/\</g, '&lt;')
                    .replace(/\>/g, '&gt;')
                    .replace(/\*([^\*]+[^\*\s]+)\*/gm, '<b>$1</b>')
                    .replace(/\n/g, '<br>') +
                '</pre>'
            )
        },
    },
}
</script>